import { Logo } from './Logo';

/** Quiet full-screen brand splash, shown while a session/app bootstraps. */
export function BrandSplash() {
  return (
    <div className="grid min-h-dvh place-items-center bg-canvas">
      <div className="animate-pulse opacity-70">
        <Logo className="h-11" />
      </div>
    </div>
  );
}
